<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UpdateModal',
})
</script>
<template>
  <Modal v-model:visible="visible" centered destroy-on-close title="编辑文件" width="500px" :confirm-loading="submitLoading" @ok="submit">
    <div class="ant-modal-bd">
      <Form ref="formRef" layout="vertical" label-align="left" :model="model" scroll-to-first-error class="ant-edit-form">
        <FormItem label="文件ID">
          <span>{{ model.id }}</span>
        </FormItem>
        <FormItem label="展示名称" name="fileShowName">
          <Input v-model:value="model.fileShowName" placeholder="请输入" allowClear />
        </FormItem>
        <FormItem label="文件编号" name="fileCodeNumber">
          <Input v-model:value="model.fileCodeNumber" placeholder="请输入" allowClear />
        </FormItem>
        <FormItem label="文件时间" name="fileShowTime">
          <DatePicker
            style="width: 100%"
            v-model:value="model.fileShowTime"
            showTime
            allowClear
            valueFormat="YYYY-MM-DD HH:mm:ss"
            placeholder="请选择"
          />
        </FormItem>
        <FormItem label="备注" name="mark">
          <Input.TextArea v-model:value="model.mark" placeholder="请输入" allowClear :auto-size="{ minRows: 3, maxRows: 6 }" />
        </FormItem>
      </Form>
    </div>
  </Modal>
</template>

<script lang="ts" setup name="UpdateModal">
import { Modal, Form, DatePicker, Input } from 'ant-design-vue'
import { FormItem } from '-/Common/Form'
import { API_FILE_EDIT } from '@/api/file'
import { useModalForm } from '@/hooks/useModalForm'
const emits = defineEmits(['refresh'])

const { visible, submitLoading, model, open, submit, formRef } = useModalForm<Partial<ApiFile.Item>>({
  initModel: (record: Partial<ApiFile.Item> = {}) => ({
    id: record.id,
    fileShowName: record.fileShowName,
    fileCodeNumber: record.fileCodeNumber,
    fileShowTime: record.fileShowTime,
    mark: record.mark
  }),
  submitFn: API_FILE_EDIT,
  onSuccess: () => emits('refresh')
})

defineExpose({ open })
</script>
